import Vue from 'vue';

function isCssColor(color) {
  return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
}

export default Vue.extend({
  props: {
    color: {
      type: String,
      default: null,
    },
  },

  methods: {
    setBackgroundColor(color, data = {}) {
      if (isCssColor(color)) {
        return {
          ...data,
          style: {
            ...data.style,
            'background-color': `${color}`,
            'border-color': `${color}`,
          },
        };
      }
      if (color) {
        return {
          ...data,
          class: {
            ...data.class,
            [color]: true,
          },
        };
      }
      return data;
    },

    setTextColor(color, data = {}) {
      if (isCssColor(color)) {
        return {
          ...data,
          style: {
            ...data.style,
            color: `${color}`,
            'caret-color': `${color}`,
          },
        };
      }
      if (color) {
        const [colorName, colorModifier] = color.toString()
          .trim()
          .split(' ', 2);
        return {
          ...data,
          class: {
            ...data.class,
            [`${colorName}_text`]: !!colorName,
            [`text_${colorModifier}`]: !!colorModifier,
          },
        };
      }
      return data;
    },
  },
});
